export const setUnvisitedPlaces = ({
  pageNumber,
  pageSize,
  places,
  isLoaded,
}) => state => {
  return {
    ...state,
    unvisitedPlaces: {
      ...state.unvisitedPlaces,
      lastFetch: {
        failed: false,
        reason: { message: "" },
      },
      items: places || [],
      loadingUnvisitedPlaces: false,
      pagination: {
        ...state.unvisitedPlaces.pagination,
        currentPageNumber: pageNumber,
        currentPageSize: pageSize,
      },
      isLoaded,
    },
  };
};
